import React from 'react'
import { Navigate } from 'react-router'

const ProtectedRoute = ({user, isDoctor, element}) => {
  return (
    (user || isDoctor) ? element : <Navigate to='/' replace/>
  )
}

export default ProtectedRoute